var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utils/init-masonry.tsx
import React17 from "react";

// src/components/masonry-provider/masonry-provider.component.tsx
import React16, { useState } from "react";
import { ObservabilityErrorBoundary as ObservabilityErrorBoundary3 } from "@leagueplatform/observability";
import { getObservabilityContext as getObservabilityContext6 } from "@leagueplatform/masonry-api";

// src/utils/log-error.ts
var MasonryLogPreffix = "[Masonry]:";
var getStylingFromString = (msg) => {
  var _a;
  const styleLength = (_a = msg.match(/%c/g)) == null ? void 0 : _a.length;
  return [...Array(styleLength)].map(
    (_, i) => `font-weight: ${i % 2 === 0 ? "bold" : "medium"}`
  );
};
var logError = (msg) => {
  if (true) {
    console.error(`${MasonryLogPreffix} ${msg}`, ...getStylingFromString(msg));
  }
};
var logWarning = (msg) => {
  if (true) {
    console.warn(`${MasonryLogPreffix} ${msg}`, ...getStylingFromString(msg));
  }
};

// src/components/widgets-wrapper/widgets-wrapper.component.tsx
import React15 from "react";
import { StackLayout as StackLayout2 } from "@leagueplatform/genesis-core";
import { ErrorPage, ERROR_TYPES } from "@leagueplatform/masonry-widgets";
import {
  useGetWidgetContainer
} from "@leagueplatform/masonry-api";

// src/components/spinner/spinner.component.tsx
import * as React2 from "react";
import { Spinner, StackLayout } from "@leagueplatform/genesis-core";

// src/hooks/use-get-config.hook.ts
import { useContext } from "react";

// src/context/masonry-config-context.tsx
import React from "react";

// src/constants/supported-api-version.ts
var MINIMUM_API_VERSION = 0;
var MAXIMUM_API_VERSION = 2;

// src/context/masonry-config-context.tsx
var defaultConfig = {
  appId: "",
  apiVersion: MINIMUM_API_VERSION,
  analytics: {
    screenName: "",
    productArea: ""
  },
  uiConfig: {
    spinnerConfig: {
      thickness: 1.5,
      size: "48px",
      tint: "$interactiveActionPrimary",
      containerHeight: "80vh"
    }
  }
};
var MasonryConfigContext = React.createContext(defaultConfig);

// src/hooks/use-get-config.hook.ts
var useGetConfig = () => {
  const config = useContext(MasonryConfigContext);
  return config;
};

// src/components/spinner/spinner.component.tsx
var MasonrySpinner = () => {
  const { uiConfig } = useGetConfig();
  const {
    spinnerConfig: { tint, size, thickness, containerHeight } = {},
    CustomLoader
  } = uiConfig;
  return /* @__PURE__ */ React2.createElement(
    StackLayout,
    {
      horizontalAlignment: "center",
      verticalAlignment: "center",
      css: { height: "100%", minHeight: containerHeight }
    },
    CustomLoader ? /* @__PURE__ */ React2.createElement(CustomLoader, null) : /* @__PURE__ */ React2.createElement(Spinner, { loading: true, tint, size, thickness })
  );
};

// src/components/widget-wrapper/widget-wrapper.component.tsx
import React10 from "react";
import { SkeletonBox } from "@leagueplatform/web-common-components";
import {
  getObservabilityContext as getObservabilityContext3,
  useGetWidgetData
} from "@leagueplatform/masonry-api";
import { ObservabilityErrorBoundary } from "@leagueplatform/observability";

// src/components/custom-widget/custom-widget.component.tsx
import React3 from "react";

// src/hooks/use-get-custom-widget-module-from-config.hook.ts
import { useMemo } from "react";

// src/utils/custom-module-utils.tsx
import {
  LargeVisualCardWidget,
  XSVisualCardWidget,
  TextAndCTACardWidget,
  SmallVisualCardWidget,
  NotificationBannerWidget,
  NotificationCardWidget,
  WelcomeBanner,
  SectionHeader,
  CarouselWidget,
  ProgressRingCardWidget,
  ProgressBarCardWidget,
  TwoUpCardWidget,
  HeroBanner,
  ImageFooter,
  MetricCardWidget
} from "@leagueplatform/masonry-widgets";
import {
  WidgetType,
  getObservabilityContext
} from "@leagueplatform/masonry-api";
import { captureError } from "@leagueplatform/observability";
var captureMasonryError = (errorMessage, context = {}, errorName) => captureError(
  new Error(errorMessage),
  getObservabilityContext(__spreadProps(__spreadValues({}, context), {
    errorName: errorName || "Masonry - Error"
  }))
);
var hasCustomModuleKey = (moduleKey, customWidgetModules = []) => customWidgetModules.some((module) => module.moduleKey === moduleKey);
var getCustomModuleByKey = (moduleKey, customWidgetModules = []) => customWidgetModules.find((module) => module.moduleKey === moduleKey);
var getCustomWidgetModule = (moduleKey, customWidgetModules, appId) => {
  if (moduleKey === "default")
    return null;
  if (!customWidgetModules || !hasCustomModuleKey(moduleKey, customWidgetModules)) {
    logError(
      `No custom module with %c moduleKey '${moduleKey}' %cprovided to Masonry config. Please check your config!!`
    );
    captureMasonryError(
      `No customWidgetModule with moduleKey ${moduleKey} provided to Masonry config.`,
      {
        tags: {
          container: appId,
          moduleKey
        }
      }
    );
    return null;
  }
  const widgetModule = getCustomModuleByKey(moduleKey, customWidgetModules);
  return widgetModule;
};
var WidgetTypeToSimpleComponentMap = {
  [WidgetType.TEXT_WITH_CTA_CARD]: TextAndCTACardWidget,
  [WidgetType.LARGE_VISUAL_CARD]: LargeVisualCardWidget,
  [WidgetType.SMALL_VISUAL_CARD]: SmallVisualCardWidget,
  [WidgetType.CAROUSEL]: CarouselWidget,
  [WidgetType.WELCOME_BANNER]: WelcomeBanner,
  [WidgetType.HERO_BANNER]: HeroBanner,
  [WidgetType.XS_VISUAL_CARD]: XSVisualCardWidget,
  [WidgetType.NOTIFICATION_BANNER]: NotificationBannerWidget,
  [WidgetType.NOTIFICATION_CARD]: NotificationCardWidget,
  [WidgetType.SECTION_HEADER]: SectionHeader,
  [WidgetType.PROGRESS_RING]: ProgressRingCardWidget,
  [WidgetType.PROGRESS_BAR]: ProgressBarCardWidget,
  [WidgetType.TWO_UP_CARD]: TwoUpCardWidget,
  [WidgetType.IMAGE_FOOTER]: ImageFooter,
  [WidgetType.METRIC_CARD]: MetricCardWidget,
  [WidgetType.HIDDEN]: () => null
};
var ProviderNameByWidgetType = {
  [WidgetType.TEXT_WITH_CTA_CARD]: "useTextWithCTACardWidgetData",
  [WidgetType.LARGE_VISUAL_CARD]: "useLargeVisualCardWidgetData",
  [WidgetType.SMALL_VISUAL_CARD]: "useSmallVisualCardWidgetData",
  [WidgetType.CAROUSEL]: "useCarouselWidgetData",
  [WidgetType.HERO_BANNER]: "useHeroBannerWidgetData",
  [WidgetType.WELCOME_BANNER]: "useWelcomeBannerWidgetData",
  // Deprecate - v2
  [WidgetType.XS_VISUAL_CARD]: "useXSVisualCardWidgetData",
  [WidgetType.NOTIFICATION_BANNER]: "useNotificationBannerWidgetData",
  [WidgetType.PROGRESS_RING]: "useProgressRingCardWidgetData",
  [WidgetType.PROGRESS_BAR]: "useProgressBarCardWidgetData",
  [WidgetType.TWO_UP_CARD]: "useTwoUpCardWidgetData",
  [WidgetType.IMAGE_FOOTER]: "useImageFooterWidgetData"
};
var getProviderFromWidgetType = (widgetData, customWidgetModule, widgetModule, appId) => {
  var _a;
  const providerName = ProviderNameByWidgetType[widgetData.type];
  const provider = (_a = customWidgetModule == null ? void 0 : customWidgetModule.customWidgetDataHooks) == null ? void 0 : _a[providerName];
  if (!provider) {
    logError(
      `Provider %c${providerName}%c for widget type - ${widgetData.type} is not provided to customWidgetModule with %c moduleKey - ${widgetModule}%c. Please check your config!!`
    );
    captureMasonryError(
      `Provider ${providerName} is not provided to customWidgetModule.`,
      {
        tags: {
          container: appId,
          widgetType: widgetData.type,
          moduleKey: widgetModule,
          widgetId: widgetData.id
        }
      }
    );
    return null;
  }
  return provider;
};
var getCustomWidgetComponent = (customWidgetModule, widgetId, appId, customType) => {
  var _a;
  if (!customType) {
    logError(
      `No %c'custom_type'%c key found for widget id ${widgetId} in widget data coming from %c'get_widget_container'%c API. Please check your Masonry container in BE.`
    );
    captureMasonryError(
      `No 'custom_type' key found for widget id ${widgetId} in widget data coming from 'get_widget_container' API`,
      {
        tags: {
          widgetId,
          container: appId
        }
      }
    );
    return null;
  }
  if (!((_a = customWidgetModule == null ? void 0 : customWidgetModule.customWidgetsUI) == null ? void 0 : _a.length)) {
    logError(
      `No 'customWidgetsUI[]' is provided in Masonry config. Please check your config!`
    );
    captureMasonryError(
      `No 'customWidgetsUI[]' is provided for moduleKey: ${customWidgetModule.moduleKey} in Masonry config`,
      {
        tags: {
          widgetId,
          container: appId,
          moduleKey: customWidgetModule.moduleKey
        }
      }
    );
    return null;
  }
  const customWidget = customWidgetModule.customWidgetsUI.find(
    ({ type: componentType }) => componentType === customType
  );
  if (!customWidget) {
    logError(
      `No custom widget with type %c${customType} %cis provided inside %c'customWidgetsUI[]'%c for moduleKey ${customWidgetModule.moduleKey}. Please check your config!`
    );
    captureMasonryError(
      `No custom widget with type ${customType} found in Masonry Config.`,
      {
        tags: {
          widgetId,
          container: appId,
          moduleKey: customWidgetModule.moduleKey
        }
      }
    );
    return null;
  }
  return customWidget.widget;
};

// src/hooks/use-get-custom-widget-module-from-config.hook.ts
var useGetCustomWidgetModuleFromConfig = ({
  moduleKey
}) => {
  const config = useGetConfig();
  const moduleProvider = useMemo(
    () => getCustomWidgetModule(
      moduleKey,
      config == null ? void 0 : config.customWidgetModules,
      config == null ? void 0 : config.appId
    ),
    [moduleKey, config == null ? void 0 : config.customWidgetModules, config == null ? void 0 : config.appId]
  );
  return moduleProvider;
};

// src/components/custom-widget/custom-widget.component.tsx
var CustomWidget = ({ widget }) => {
  const config = useGetConfig();
  const moduleProvider = useGetCustomWidgetModuleFromConfig({
    moduleKey: widget.module
  });
  const CustomWidgetComponent = getCustomWidgetComponent(
    moduleProvider,
    widget.id,
    config == null ? void 0 : config.appId,
    widget.custom_type
  );
  if (!CustomWidgetComponent)
    return null;
  return /* @__PURE__ */ React3.createElement(CustomWidgetComponent, { widget });
};

// src/components/widget-provider-from-type/widget-provider-from-widget-type.component.tsx
import React9 from "react";
import { getObservabilityContext as getObservabilityContext2 } from "@leagueplatform/masonry-api";
import { captureMessage } from "@leagueplatform/observability";

// src/components/default-widget/default-widget.tsx
import React4, { useMemo as useMemo2 } from "react";
import { useGetTraitsForMedia } from "@leagueplatform/masonry-widgets";

// src/utils/widget-data-mapping.ts
var convertToCamelCase = (str) => str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
var createObjectMapping = (obj) => Object.keys(obj).reduce((finalObj, key) => {
  finalObj[convertToCamelCase(key)] = obj[key];
  return finalObj;
}, {});
var mapXSVisualCardData = (params) => createObjectMapping(params);
var mapNotificationBannerData = (params) => createObjectMapping(params);
var mapLargeAndSmallVisualCardData = (params) => createObjectMapping(params);
var mapTextWithCTACardData = (params) => createObjectMapping(params);
var mapCarousalData = (params) => __spreadProps(__spreadValues({}, createObjectMapping(params)), {
  items: params.items.map((cardItem) => createObjectMapping(cardItem))
});
var mapTwoUpCardData = (params) => __spreadProps(__spreadValues({}, createObjectMapping(params)), {
  items: params.items.map((cardItem) => createObjectMapping(cardItem))
});
var mapProgressBarCardData = (params) => createObjectMapping(params);
var mapProgressRingCardData = (params) => createObjectMapping(params);
var mapWidgetDataFromAPI = (data, widgetType) => {
  switch (widgetType) {
    case "text_with_button":
      return mapTextWithCTACardData(data);
    case "text_with_large_image":
      return mapLargeAndSmallVisualCardData(data);
    case "text_with_small_image":
      return mapLargeAndSmallVisualCardData(data);
    case "carousel":
      return mapCarousalData(data);
    case "notification_banner":
      return mapNotificationBannerData(data);
    case "xs_visual_card":
      return mapXSVisualCardData(data);
    case "2_up_card":
      return mapTwoUpCardData(data);
    case "progress_bar":
      return mapProgressBarCardData(data);
    case "progress_ring":
      return mapProgressRingCardData(data);
    default:
      return createObjectMapping(data);
  }
};

// src/utils/merge-default-and-custom-widget-data.ts
var mergeDefaultAndCustomWidgetData = (defaultData, customWidgetData) => __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, (customWidgetData == null ? void 0 : customWidgetData.displayData) || {}), (customWidgetData == null ? void 0 : customWidgetData.widgetSettings) || {}), mapWidgetDataFromAPI((defaultData == null ? void 0 : defaultData.attributes) || {}, defaultData.type) || {}), {
  traits: defaultData == null ? void 0 : defaultData.traits
});

// src/utils/widget-analytics-events.ts
import { trackAnalyticsEvent, EVENT_NAME } from "@leagueplatform/analytics";
import { WidgetType as WidgetType2 } from "@leagueplatform/masonry-api";

// src/constants/analytics-event-detail-mapping.ts
var DetailLargeVisualCardButtonClick = "text_with_large_image";
var DetailSmallVisualCardButtonClick = "text_with_small_image";
var DetailXSVisualCardButtonClick = "text_with_xsmall_image";
var DetailNotificationBannerButtonClick = "notification_banner";
var DetailNotificationBannerDismissClick = "notification_banner_dismiss_button";
var DetailNotificationCardButtonClick = "notification_card";
var DetailProgressRingButtonClick = "progress_ring";
var DetailProgressBarButtonClick = "progress_bar";
var DetailHeroBannerButtonClick = "welcome_banner_primary_button";
var DetailTextWithCTAButtonClick = "text_with_button_primary_button";
var Detail2UpCardWithCTAButtonClick = "2_up_card";
var DetailMetricCardButtonClick = "metric_card";
var DetailCarouselScrollRight = "scroll carousel right";
var DetailCarouselScrollLeft = "scroll carousel left";
var DetailCarouselHeaderButtonClick = "carousel_header_button";
var DetailCarouselHeaderSelectItem = "select item from carousel";
var DetailStackSelectItem = "select item from stack";

// src/utils/widget-analytics-events.ts
var getDataForAnalyticsByWidgetType = (type, widgetAttributesAndTraits) => {
  switch (type) {
    case WidgetType2.XS_VISUAL_CARD:
      return {
        text_detail: widgetAttributesAndTraits.heading,
        text_sub_detail: widgetAttributesAndTraits.body,
        link_url: widgetAttributesAndTraits.linkUrl
      };
    case WidgetType2.PROGRESS_BAR:
      return {
        text_detail: widgetAttributesAndTraits.eyebrow,
        current_progress: widgetAttributesAndTraits.currentText,
        maximum_progress: widgetAttributesAndTraits.suffixText,
        remaining_progress: widgetAttributesAndTraits.footerText,
        progress_percent: widgetAttributesAndTraits.progress,
        link_url: widgetAttributesAndTraits.action
      };
    case WidgetType2.PROGRESS_RING:
      return {
        text_detail: widgetAttributesAndTraits.eyebrow,
        current_progress: widgetAttributesAndTraits.currentText,
        maximum_progress: widgetAttributesAndTraits.suffixText,
        progress_percent: widgetAttributesAndTraits.progress,
        link_url: widgetAttributesAndTraits.action
      };
    case WidgetType2.HERO_BANNER:
      return {
        text_detail: widgetAttributesAndTraits.buttonLabel,
        link_url: widgetAttributesAndTraits.buttonAction
      };
    case WidgetType2.NOTIFICATION_CARD:
      return {
        text_detail: widgetAttributesAndTraits.heading,
        text_sub_detail: widgetAttributesAndTraits.subheading,
        link_url: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.url
      };
    case WidgetType2.METRIC_CARD:
      return {
        text_detail: widgetAttributesAndTraits.heading
      };
    default:
      return {
        text_detail: widgetAttributesAndTraits.title,
        text_sub_detail: widgetAttributesAndTraits.description,
        link_url: widgetAttributesAndTraits.linkUrl
      };
  }
};
var widgetAnalyticsEvents = (config, widgetType, widgetAttributesAndTraits, productIdentifier) => {
  const trackMasonryAnalytics2 = (event, widgetProperties) => () => {
    var _a, _b, _c;
    return trackAnalyticsEvent(event, __spreadValues(__spreadValues({
      product_area: (_a = config == null ? void 0 : config.analytics) == null ? void 0 : _a.productArea,
      sub_product_area: config == null ? void 0 : config.appId,
      screen_name: (_b = config == null ? void 0 : config.analytics) == null ? void 0 : _b.screenName,
      product_identifier: productIdentifier
    }, ((_c = config == null ? void 0 : config.analytics) == null ? void 0 : _c.subDetail) ? { sub_detail: config.analytics.subDetail } : {}), widgetProperties));
  };
  const getCarouselAnalyticEvents = () => {
    var _a, _b;
    const carouselRollup = {
      carousel_array: (_a = widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.items) == null ? void 0 : _a.map(
        (carouselItem) => carouselItem.title
      ),
      carousel_name: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.title,
      carousel_num_resources: (_b = widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.items) == null ? void 0 : _b.length
    };
    return {
      onScrollLeft: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollLeft
      }, carouselRollup)),
      onScrollRight: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollRight
      }, carouselRollup)),
      onSelectItem: (item, index) => trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderSelectItem,
        sub_detail: item.title,
        text_detail: item.overline,
        carousel_index: index,
        link_url: item.linkUrl
      }, carouselRollup))(),
      onSelectHeader: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderButtonClick,
        sub_detail: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.headerLinkHint,
        link_url: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.headerLinkUrl
      }, carouselRollup))
    };
  };
  const getTwoUpCardAnalyticsEvent = () => ({
    onItemClick: ({ heading, body, actionLink }, index) => trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, {
      detail: Detail2UpCardWithCTAButtonClick,
      text_detail: heading,
      text_sub_detail: body,
      container_index: index,
      link_url: actionLink
    })()
  });
  const getNotificationBannerAnalyticsEvent = () => __spreadProps(__spreadValues({}, (widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.url) && {
    onCardClick: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, {
      detail: DetailNotificationBannerButtonClick,
      text_detail: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.heading,
      text_sub_detail: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.body,
      link_url: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.url
    })
  }), {
    onDismiss: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, {
      detail: DetailNotificationBannerDismissClick,
      text_detail: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.heading,
      text_sub_detail: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.body,
      link_url: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.url
    })
  });
  const getStackAnalyticsEvents = () => {
    const stackRollup = {
      stack_array: widgetAttributesAndTraits.items.map(
        (stackItem) => {
          var _a, _b;
          return ((_a = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _a.title) || ((_b = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _b.heading);
        }
      ),
      stack_name: widgetAttributesAndTraits.heading,
      stack_num_resources: widgetAttributesAndTraits.items.length
    };
    return {
      onItemClick: ({ attributes, type }, index) => trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues(__spreadValues({
        detail: DetailStackSelectItem,
        stack_index: index,
        component_detail: type
      }, getDataForAnalyticsByWidgetType(
        type,
        attributes
      )), stackRollup))()
    };
  };
  const getGenericCarouselAnalyticsEvents = () => {
    const carouselRollup = {
      carousel_array: widgetAttributesAndTraits.items.map(
        (stackItem) => {
          var _a, _b;
          return ((_a = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _a.title) || ((_b = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _b.heading);
        }
      ),
      carousel_name: widgetAttributesAndTraits.heading,
      carousel_num_resources: widgetAttributesAndTraits.items.length
    };
    return {
      onScrollLeft: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollLeft
      }, carouselRollup)),
      onScrollRight: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollRight
      }, carouselRollup)),
      onItemClick: ({ attributes, type }, index) => trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues(__spreadValues({
        detail: DetailCarouselHeaderSelectItem,
        carousel_index: index,
        component_detail: type
      }, getDataForAnalyticsByWidgetType(
        type,
        attributes
      )), carouselRollup))(),
      onSelectHeader: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderButtonClick,
        sub_detail: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.headerButtonLabel,
        link_url: widgetAttributesAndTraits == null ? void 0 : widgetAttributesAndTraits.headerButtonAction
      }, carouselRollup))
    };
  };
  const getCommonAnalyticsEvent = (widgetDetail) => () => ({
    onCardClick: trackMasonryAnalytics2(EVENT_NAME.BUTTON_CLICKED, __spreadValues({
      detail: widgetDetail
    }, getDataForAnalyticsByWidgetType(widgetType, widgetAttributesAndTraits)))
  });
  const getWidgetAnalyticsFromType = {
    /* ---- Complex Widgets ----*/
    [WidgetType2.CAROUSEL]: getCarouselAnalyticEvents,
    [WidgetType2.TWO_UP_CARD]: getTwoUpCardAnalyticsEvent,
    [WidgetType2.STACK]: getStackAnalyticsEvents,
    [WidgetType2.GENERIC_CAROUSEL]: getGenericCarouselAnalyticsEvents,
    /* ---- Simple Widgets ----*/
    [WidgetType2.HERO_BANNER]: getCommonAnalyticsEvent(
      DetailHeroBannerButtonClick
    ),
    [WidgetType2.PROGRESS_BAR]: getCommonAnalyticsEvent(
      DetailProgressBarButtonClick
    ),
    [WidgetType2.PROGRESS_RING]: getCommonAnalyticsEvent(
      DetailProgressRingButtonClick
    ),
    [WidgetType2.XS_VISUAL_CARD]: getCommonAnalyticsEvent(
      DetailXSVisualCardButtonClick
    ),
    [WidgetType2.NOTIFICATION_BANNER]: getNotificationBannerAnalyticsEvent,
    [WidgetType2.NOTIFICATION_CARD]: getCommonAnalyticsEvent(
      DetailNotificationCardButtonClick
    ),
    [WidgetType2.TEXT_WITH_CTA_CARD]: getCommonAnalyticsEvent(
      DetailTextWithCTAButtonClick
    ),
    [WidgetType2.LARGE_VISUAL_CARD]: getCommonAnalyticsEvent(
      DetailLargeVisualCardButtonClick
    ),
    [WidgetType2.SMALL_VISUAL_CARD]: getCommonAnalyticsEvent(
      DetailSmallVisualCardButtonClick
    ),
    [WidgetType2.METRIC_CARD]: getCommonAnalyticsEvent(
      DetailMetricCardButtonClick
    )
  };
  const widgetAnalyticsEventsFn = getWidgetAnalyticsFromType[widgetType];
  return widgetAnalyticsEventsFn ? widgetAnalyticsEventsFn() : {};
};

// src/components/default-widget/default-widget.tsx
var DefaultWidget = ({
  data,
  config,
  component: WidgetComponent,
  isChildItem = false,
  onCardClick
}) => {
  const { type: widgetType, product_identifier: productIdentifier } = data;
  const traits = useGetTraitsForMedia(data.traits);
  const widgetAttributesAndTraits = mergeDefaultAndCustomWidgetData(data);
  const widgetAnalyticsProps = useMemo2(() => {
    if (!onCardClick) {
      return widgetAnalyticsEvents(
        config,
        widgetType,
        widgetAttributesAndTraits,
        productIdentifier
      );
    }
    return {};
  }, [
    onCardClick,
    config,
    widgetType,
    widgetAttributesAndTraits,
    productIdentifier
  ]);
  const dismissibleLink = useMemo2(
    () => {
      var _a;
      return (_a = data.links) == null ? void 0 : _a.find((link) => link.rel === "dismiss");
    },
    [data.links]
  );
  return /* @__PURE__ */ React4.createElement(
    WidgetComponent,
    __spreadProps(__spreadValues(__spreadValues(__spreadValues({
      onCardClick
    }, widgetAttributesAndTraits), traits), widgetAnalyticsProps), {
      dismissibleLink,
      isChildItem,
      product_identifier: productIdentifier
    })
  );
};

// src/constants/widget-type-to-complex-component-map.ts
import { WidgetType as WidgetType4 } from "@leagueplatform/masonry-api";

// src/components/generic-carousel/generic-carousel.component.tsx
import * as React5 from "react";
import {
  GenericCarouselWidget,
  COMPLEX_WIDGET_CARDS_WIDTH
} from "@leagueplatform/masonry-widgets";
import { StackItem } from "@leagueplatform/genesis-core";
import { uniqueId } from "lodash";
var GenericCarousel = (_a) => {
  var _b = _a, {
    items,
    onItemClick
  } = _b, props = __objRest(_b, [
    "items",
    "onItemClick"
  ]);
  const config = useGetConfig();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ React5.createElement(GenericCarouselWidget, __spreadValues({}, props), items == null ? void 0 : items.map((item, index) => {
      const WidgetComponent = WidgetTypeToSimpleComponentMap[item.type];
      if (!WidgetComponent)
        return null;
      return /* @__PURE__ */ React5.createElement(
        StackItem,
        {
          css: { minWidth: COMPLEX_WIDGET_CARDS_WIDTH, height: "100%" }
        },
        /* @__PURE__ */ React5.createElement(
          DefaultWidget,
          {
            key: uniqueId(),
            data: item,
            component: WidgetComponent,
            config,
            onCardClick: () => onItemClick(item, index),
            isChildItem: true
          }
        )
      );
    }))
  );
};

// src/components/stack-widget/stack-widget.component.tsx
import * as React7 from "react";
import {
  StackWidgetWrapper,
  useGetTraitsForMedia as useGetTraitsForMedia2,
  DefaultOrientationMap,
  useOrientationFromMediaQuery
} from "@leagueplatform/masonry-widgets";
import { WidgetType as WidgetType3 } from "@leagueplatform/masonry-api";

// src/components/stack-widget/stack-widget-items-list.component.tsx
import React6 from "react";
import { COMPLEX_WIDGET_CARDS_WIDTH as COMPLEX_WIDGET_CARDS_WIDTH2 } from "@leagueplatform/masonry-widgets";
import { StackItem as StackItem2 } from "@leagueplatform/genesis-core";
import { Orientation } from "@leagueplatform/masonry-api";
var StackItemsList = ({
  items,
  orientation,
  onItemClick
}) => {
  const config = useGetConfig();
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, items.map((item, index) => {
    const WidgetComponent = WidgetTypeToSimpleComponentMap[item.type];
    if (!WidgetComponent)
      return null;
    return /* @__PURE__ */ React6.createElement(
      StackItem2,
      {
        key: `${item.type}${index}`,
        css: { minWidth: COMPLEX_WIDGET_CARDS_WIDTH2 }
      },
      /* @__PURE__ */ React6.createElement(
        DefaultWidget,
        {
          data: item,
          component: WidgetComponent,
          config,
          isChildItem: orientation === Orientation.HORIZONTAL,
          onCardClick: () => onItemClick(item, index)
        }
      )
    );
  }));
};

// src/components/stack-widget/stack-widget.component.tsx
var StackWidget = ({
  heading,
  items,
  traits,
  onItemClick
}) => {
  const orientation = useOrientationFromMediaQuery({
    traits,
    defaultOrientation: DefaultOrientationMap[WidgetType3.STACK]
  });
  const traitItems = useGetTraitsForMedia2(traits);
  return /* @__PURE__ */ React7.createElement(
    StackWidgetWrapper,
    {
      orientation,
      heading,
      gridColumnCount: traitItems == null ? void 0 : traitItems.gridColumnCount
    },
    /* @__PURE__ */ React7.createElement(
      StackItemsList,
      {
        onItemClick,
        items,
        orientation
      }
    )
  );
};

// src/constants/widget-type-to-complex-component-map.ts
var WidgetTypeToComplexComponentMap = __spreadProps(__spreadValues({}, WidgetTypeToSimpleComponentMap), {
  [WidgetType4.STACK]: StackWidget,
  [WidgetType4.GENERIC_CAROUSEL]: GenericCarousel
});

// src/components/widget-provider-from-type/widget-with-custom-module-provider.component.tsx
import React8 from "react";
var WidgetWithCustomModuleProvider = (_a) => {
  var _b = _a, {
    moduleProviderHook,
    widget,
    data,
    component: Component,
    config
  } = _b, props = __objRest(_b, [
    "moduleProviderHook",
    "widget",
    "data",
    "component",
    "config"
  ]);
  const { type: widgetType } = data;
  const customWidgetData = moduleProviderHook({ widget });
  const widgetAttributesAndTraits = mergeDefaultAndCustomWidgetData(
    data,
    customWidgetData
  );
  const widgetAnalyticsProps = widgetAnalyticsEvents(
    config,
    widgetType,
    widgetAttributesAndTraits,
    data == null ? void 0 : data.product_identifier
  );
  return /* @__PURE__ */ React8.createElement(
    Component,
    __spreadValues(__spreadValues(__spreadValues({}, widgetAttributesAndTraits), props), widgetAnalyticsProps)
  );
};

// src/components/widget-provider-from-type/widget-provider-from-widget-type.component.tsx
var WidgetProviderFromWidgetType = ({
  data,
  widget
}) => {
  const config = useGetConfig();
  const { type: widgetType } = data;
  const { module: moduleKey } = widget;
  const customWidgetModule = useGetCustomWidgetModuleFromConfig({
    moduleKey
  });
  const WidgetComponent = WidgetTypeToComplexComponentMap[widgetType];
  if (!WidgetComponent) {
    logWarning(
      `Unsupported widget type - %c${widgetType}%c found in container.`
    );
    captureMessage(
      `Unsupported widget type - ${widgetType} found in container.`,
      getObservabilityContext2({
        tags: {
          container: config.appId
        }
      })
    );
    return null;
  }
  if (widget.module !== "default") {
    const widgetProviderHook = getProviderFromWidgetType(
      data,
      customWidgetModule,
      widget.module,
      config.appId
    );
    if (widgetProviderHook) {
      return /* @__PURE__ */ React9.createElement(
        WidgetWithCustomModuleProvider,
        {
          moduleProviderHook: widgetProviderHook,
          data,
          widget,
          component: WidgetComponent,
          config
        }
      );
    }
    logWarning(
      `No custom widget provider found for widget type - %c${widgetType}%c and moduleKey - %c${widget.module}%c. Rendering widget with masonry data.`
    );
    captureMessage(
      `No custom widget provider found for widget type: ${widgetType}`,
      getObservabilityContext2({
        tags: {
          container: config.appId,
          widgetType,
          moduleKey: widget.module
        }
      })
    );
  }
  if (!data.attributes)
    return null;
  return /* @__PURE__ */ React9.createElement(DefaultWidget, { component: WidgetComponent, data, config });
};

// src/components/widget-wrapper/widget-wrapper.component.tsx
var MasonrySupportedWidget = ({ widget }) => {
  const { apiVersion } = useGetConfig();
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData(widget, apiVersion);
  if (isLoading)
    return /* @__PURE__ */ React10.createElement(SkeletonBox, { width: "100%", height: "120px" });
  if (error || !widgetData) {
    return null;
  }
  return /* @__PURE__ */ React10.createElement(WidgetProviderFromWidgetType, { data: widgetData, widget });
};
var WidgetWrapper = ({
  widget,
  appId
}) => (
  // Returning null as fallback component because masonry should not display anything if a widget fails to render
  /* @__PURE__ */ React10.createElement(
    ObservabilityErrorBoundary,
    {
      fallback: () => null,
      errorContext: getObservabilityContext3({
        tags: {
          errorName: `Masonry - Error while rendering widget: ${widget.id}`,
          container: appId,
          widgetId: widget.id,
          widgetType: widget.type
        }
      }),
      onError: (err) => {
        logError(
          `Masonry - Error while rendering widget: ${widget.id} ${err.message}`
        );
      }
    },
    widget.type === "custom_component" ? /* @__PURE__ */ React10.createElement(CustomWidget, { widget }) : /* @__PURE__ */ React10.createElement(MasonrySupportedWidget, { widget })
  )
);

// src/components/widget-wrapper/widget-wrapper-v2.component.tsx
import React14 from "react";
import {
  getObservabilityContext as getObservabilityContext5,
  useGetWidgetData as useGetWidgetData2
} from "@leagueplatform/masonry-api";
import { ObservabilityErrorBoundary as ObservabilityErrorBoundary2 } from "@leagueplatform/observability";

// src/components/spinner/masonry-skeleton.component.tsx
import React11 from "react";
import { useIntl } from "react-intl";
import { Box, VisuallyHidden } from "@leagueplatform/genesis-core";

// src/utils/skeleton-type-to-component-map.ts
import {
  ExtraSmallSkeleton,
  HeroBannerSkeleton,
  LargeSkeleton,
  SmallSkeleton
} from "@leagueplatform/masonry-widgets";
var SkeletonTypeToComponentMap = {
  loadingSmall: SmallSkeleton,
  loadingLarge: LargeSkeleton,
  loadingExtraSmall: ExtraSmallSkeleton,
  loadingHeroBanner: HeroBannerSkeleton
};

// src/components/spinner/masonry-skeleton.component.tsx
var MasonrySkeleton = ({
  loading
}) => {
  const { formatMessage } = useIntl();
  if (loading == null ? void 0 : loading.type) {
    const LoadingComponent = SkeletonTypeToComponentMap[loading == null ? void 0 : loading.type];
    if (LoadingComponent) {
      return /* @__PURE__ */ React11.createElement(Box, { "aria-busy": true, "aria-live": "polite" }, /* @__PURE__ */ React11.createElement(VisuallyHidden, null, formatMessage({ id: "LOADING" })), /* @__PURE__ */ React11.createElement(LoadingComponent, null));
    }
  }
  return null;
};

// src/components/widget-provider-from-type/widget-provider-from-widget-type-v2.component.tsx
import React13 from "react";
import {
  getObservabilityContext as getObservabilityContext4
} from "@leagueplatform/masonry-api";
import { captureMessage as captureMessage2 } from "@leagueplatform/observability";

// src/components/custom-widget/custom-widget-with-widget-data.component.tsx
import React12 from "react";
var CustomWidgetWithWidgetData = ({
  data
}) => {
  const config = useGetConfig();
  const moduleProvider = useGetCustomWidgetModuleFromConfig({
    moduleKey: data.module
  });
  const CustomWidgetComponent = getCustomWidgetComponent(
    moduleProvider,
    data.id,
    config == null ? void 0 : config.appId,
    data.type
  );
  if (!CustomWidgetComponent)
    return null;
  return /* @__PURE__ */ React12.createElement(CustomWidgetComponent, { widget: data });
};

// src/components/widget-provider-from-type/widget-provider-from-widget-type-v2.component.tsx
var WidgetProviderFromWidgetTypeV2 = ({
  data
}) => {
  const config = useGetConfig();
  const { type: widgetType, module } = data;
  if (widgetType && module)
    return /* @__PURE__ */ React13.createElement(
      CustomWidgetWithWidgetData,
      {
        data
      }
    );
  const WidgetComponent = WidgetTypeToComplexComponentMap[widgetType];
  if (!WidgetComponent) {
    logWarning(
      `Unsupported widget type - %c${widgetType}%c found in container.`
    );
    captureMessage2(
      `Unsupported widget type - ${widgetType} found in container.`,
      getObservabilityContext4({
        tags: {
          container: config.appId
        }
      })
    );
    return null;
  }
  if (!data.attributes)
    return null;
  return /* @__PURE__ */ React13.createElement(DefaultWidget, { component: WidgetComponent, data, config });
};

// src/components/widget-wrapper/widget-wrapper-v2.component.tsx
var MasonrySupportedWidget2 = ({ widget }) => {
  const { apiVersion } = useGetConfig();
  const { loading } = widget;
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData2(widget, apiVersion);
  if (isLoading) {
    return /* @__PURE__ */ React14.createElement(MasonrySkeleton, { loading });
  }
  if (error || !widgetData) {
    return null;
  }
  return /* @__PURE__ */ React14.createElement(WidgetProviderFromWidgetTypeV2, { data: widgetData });
};
var WidgetWrapperV2 = ({
  widget,
  appId
}) => (
  // Returning null as fallback component because masonry should not display anything if a widget fails to render
  /* @__PURE__ */ React14.createElement(
    ObservabilityErrorBoundary2,
    {
      fallback: () => null,
      errorContext: getObservabilityContext5({
        tags: {
          errorName: `Masonry - Error while rendering widget: ${widget.id}`,
          container: appId,
          widgetId: widget.id
        }
      }),
      onError: (err) => {
        logError(
          `Masonry - Error while rendering widget: ${widget.id} ${err.message}`
        );
      }
    },
    widget.module !== "default" && widget.custom_type ? /* @__PURE__ */ React14.createElement(CustomWidget, { widget }) : /* @__PURE__ */ React14.createElement(MasonrySupportedWidget2, { widget })
  )
);

// src/components/widgets-wrapper/widgets-wrapper.component.tsx
var WidgetsWrapper = () => {
  const { appId, apiVersion, apiParams } = useGetConfig();
  const { data, isLoading, error } = useGetWidgetContainer(
    appId,
    apiVersion,
    apiParams
  );
  const { widgets } = data || {};
  if (error) {
    return /* @__PURE__ */ React15.createElement(ErrorPage, { errorType: ERROR_TYPES.API_ERROR });
  }
  if (isLoading) {
    return /* @__PURE__ */ React15.createElement(MasonrySpinner, null);
  }
  if (apiVersion < 2)
    return /* @__PURE__ */ React15.createElement(StackLayout2, { spacing: "$two", horizontalAlignment: "stretch" }, widgets == null ? void 0 : widgets.map(
      (widget) => /* @__PURE__ */ React15.createElement(WidgetWrapper, { widget, key: widget == null ? void 0 : widget.id, appId })
    ));
  return /* @__PURE__ */ React15.createElement(StackLayout2, { spacing: "$two", horizontalAlignment: "stretch" }, widgets == null ? void 0 : widgets.map(
    (widget) => /* @__PURE__ */ React15.createElement(WidgetWrapperV2, { widget, key: widget == null ? void 0 : widget.id, appId })
  ));
};

// src/components/masonry-provider/masonry-provider.component.tsx
var MasonryProvider = ({
  config
}) => {
  const [masonryConfig] = useState(config);
  return /* @__PURE__ */ React16.createElement(
    ObservabilityErrorBoundary3,
    {
      fallback: () => null,
      errorContext: getObservabilityContext6({
        tags: {
          errorName: `Masonry - Error while rendering Masonry Container: ${config == null ? void 0 : config.appId}`,
          container: config == null ? void 0 : config.appId
        }
      }),
      onError: (err) => {
        logError(
          `Masonry - Error while rendering Masonry Container: ${err.message}`
        );
      }
    },
    /* @__PURE__ */ React16.createElement(MasonryConfigContext.Provider, { value: masonryConfig }, /* @__PURE__ */ React16.createElement(WidgetsWrapper, null))
  );
};

// src/utils/validate-config.ts
import { merge } from "lodash";

// src/utils/masonry-config-schema.ts
import {
  object,
  optional,
  number,
  string,
  array,
  func,
  union,
  record,
  boolean
} from "superstruct";
var CommonRecordValuesApiParams = union([string(), number(), boolean()]);
var ApiParamsSchema = record(string(), CommonRecordValuesApiParams);
var MasonryConfigSchema = object({
  appId: string(),
  apiVersion: number(),
  apiParams: optional(
    record(
      string(),
      union([
        CommonRecordValuesApiParams,
        array(CommonRecordValuesApiParams),
        ApiParamsSchema
      ])
    )
  ),
  customWidgetModules: optional(
    array(
      object({
        moduleKey: string(),
        customWidgetDataHooks: optional(
          object({
            useTextWithCTACardWidgetData: optional(func()),
            useLargeVisualCardWidgetData: optional(func()),
            useSmallVisualCardWidgetData: optional(func()),
            useCarouselWidgetData: optional(func()),
            useXSVisualCardWidgetData: optional(func()),
            useWelcomeBannerWidgetData: optional(func()),
            // Deprecate - v2
            useHeroBannerWidgetData: optional(func()),
            useProductCarouselWidgetData: optional(func()),
            useProgressRingCardWidgetData: optional(func()),
            useProgressBarCardWidgetData: optional(func()),
            useTwoUpCardWidgetData: optional(func()),
            useGenericCarouselWidgetData: optional(func()),
            useStackWidgetData: optional(func()),
            useImageFooterWidgetData: optional(func())
          })
        ),
        customWidgetsUI: optional(
          array(
            object({
              type: string(),
              widget: func()
            })
          )
        )
      })
    )
  ),
  analytics: object({
    productArea: string(),
    screenName: string(),
    subDetail: optional(string())
  }),
  uiConfig: optional(
    object({
      CustomLoader: optional(func()),
      spinnerConfig: optional(
        object({
          tint: optional(string()),
          size: optional(union([string(), number()])),
          thickness: optional(number()),
          containerHeight: optional(string())
        })
      )
    })
  )
});

// src/utils/validate-config-with-schema.ts
import { validate } from "superstruct";
function validateConfigWithSchema(config, schema) {
  const messageSuffix = " is required when initializing Masonry";
  const [err] = validate(config, schema);
  if (!err) {
    return [];
  }
  return err.failures().map((failure) => failure.key + messageSuffix);
}

// src/utils/validate-config.ts
var formatConfigWithDefaultValues = (config) => merge({}, defaultConfig, config);
function validateAndFormatConfig(config) {
  if (!config)
    throw new Error(
      "Please provide a configuration object to initialize Masonry"
    );
  const errors = validateConfigWithSchema(config, MasonryConfigSchema);
  if (errors == null ? void 0 : errors.length)
    throw new Error(`
${errors.join("\n")}`);
  if (config.apiVersion < MINIMUM_API_VERSION || config.apiVersion > MAXIMUM_API_VERSION) {
    throw new Error(
      `
The apiVersion provided is not supported by masonry module. Please provide a version between ${MINIMUM_API_VERSION} & ${MAXIMUM_API_VERSION} `
    );
  }
  const formattedConfig = formatConfigWithDefaultValues(config);
  return formattedConfig;
}

// src/utils/init-masonry.tsx
var Masonry = class {
  constructor(clientConfig) {
    this.Provider = () => /* @__PURE__ */ React17.createElement(MasonryProvider, { config: this.config });
    this.checkConfigForNullOrUndefined(clientConfig);
    this.config = validateAndFormatConfig(clientConfig);
  }
  checkConfigForNullOrUndefined(config) {
    if (!config && !this.config) {
      throw new Error(
        "No config provided for Masonry Module. Please use Masonry.init() to initialize Masonry."
      );
    }
  }
  getConfig() {
    this.checkConfigForNullOrUndefined();
    return this.config;
  }
  validateConfig() {
    this.checkConfigForNullOrUndefined();
    validateAndFormatConfig(this.config);
  }
  setConfig(clientConfig) {
    this.checkConfigForNullOrUndefined();
    this.config = validateAndFormatConfig(clientConfig);
  }
};
var initMasonry = (config) => new Masonry(config);

// src/components/masonry-pdf/masonry-pdf.component.tsx
import { useEffect, useState as useState2 } from "react";
import { getConfig } from "@leagueplatform/core";
import { useGeneratePDFReport } from "@leagueplatform/masonry-api";
import {
  useParamsLegacy as useParams,
  useQueryParams
} from "@leagueplatform/routing";
var MasonryPDF = ({
  loader: LoadingComponent
}) => {
  const [generatePDF, setGeneratePDF] = useState2(false);
  const params = useParams();
  const query = useQueryParams();
  const filename = query.get("filename");
  const templateId = query.get("templateId");
  useEffect(() => {
    if (params.containerType && params.version)
      setGeneratePDF(true);
  }, [params]);
  console.log("params, query params", params, filename, templateId);
  const { isError, data, isLoading } = useGeneratePDFReport(generatePDF, __spreadValues({
    containerId: params.containerType,
    filename: filename || `${params.containerType}_${params.version}_report`,
    version: +params.version
  }, templateId && { templateId }));
  console.log("Error and Data from get PDF container", isError, data);
  useEffect(() => {
    if (data)
      getConfig().config.core.customMethods.handleLink(data, "_self");
  }, [data]);
  if (isLoading)
    return LoadingComponent;
  return null;
};

// src/constants/masonry-routes.ts
var MASONRY_ROUTES = {
  PDF_GENERATION: "/masonry/pdf/:version/:containerType"
};

// src/components/generic-masonry-page/generic-masonry-page.component.tsx
import React19 from "react";
import { Route, useParamsLegacy as useParams2 } from "@leagueplatform/routing";
import { MasonryEngine } from "@leagueplatform/masonry-engine";
import { StackLayout as StackLayout3 } from "@leagueplatform/genesis-core";
import { useSearchParams } from "@leagueplatform/web-common";

// src/masonry-engine/masonry-driver/get-masonry-driver.ts
import { getMasonryRootNode } from "@leagueplatform/masonry-api";
import {
  createMasonryEngineActionController
} from "@leagueplatform/masonry-engine";

// src/masonry-engine/masonry-driver/masonry-driver-node-renderers-registry.ts
import {
  DEFAULT_NAMESPACE
} from "@leagueplatform/masonry-engine";
import { merge as merge2 } from "lodash";

// src/masonry-engine/masonry-driver/masonry-default-node-renderers-map.tsx
import {
  MasonryCarouselRenderer,
  MasonryColumnLayoutRenderer,
  MasonryCTACardRenderer,
  MasonryHeroBannerRenderer,
  MasonryImageBannerRenderer,
  MasonryLargeCardRenderer,
  MasonryMetricCardRenderer,
  MasonryNotificationBannerRenderer,
  MasonryNotificationCardRenderer,
  MasonryProgressBarCardRenderer,
  MasonryProgressRingCardRenderer,
  MasonrySectionHeaderRenderer,
  MasonrySmallCardRenderer,
  MasonryMicroCardRenderer,
  MasonryExtraSmallCardRenderer,
  MasonryVerticalLayoutRenderer,
  MasonryHorizontalLayoutRenderer,
  MasonryGridLayoutRenderer,
  MasonryLoaderRenderer,
  MasonryTabsRenderer,
  MasonrySidebarLayoutRenderer,
  MasonryTextActionRenderer,
  MasonryButtonRenderer,
  MasonryFormRenderer,
  MasonryVideoRenderer,
  MasonryStatusBannerRenderer,
  MasonryTextInputRenderer,
  MasonryContentBlockRenderer,
  MasonryAccordionItemRenderer,
  MasonrySelectInputRenderer,
  MasonryStickyLayoutRenderer,
  MasonryCheckboxRenderer,
  MasonryRadioRenderer,
  MasonrySegmentControlRenderer,
  MasonryBasicTableRenderer,
  MasonryDividerRenderer,
  MasonryComposableCardRenderer
} from "@leagueplatform/masonry-renderers";
var MasonryDriverDefaultNodeRendererMap = {
  carousel: MasonryCarouselRenderer,
  // @TODO fix naming of column layout type
  column_layout: MasonryColumnLayoutRenderer,
  containerSpinner: MasonrySpinner,
  contentBlock: MasonryContentBlockRenderer,
  ctaCard: MasonryCTACardRenderer,
  extraSmallCard: MasonryExtraSmallCardRenderer,
  composableCard: MasonryComposableCardRenderer,
  form: MasonryFormRenderer,
  gridLayout: MasonryGridLayoutRenderer,
  heroBanner: MasonryHeroBannerRenderer,
  hidden: () => null,
  horizontalLayout: MasonryHorizontalLayoutRenderer,
  imageBanner: MasonryImageBannerRenderer,
  largeCard: MasonryLargeCardRenderer,
  loader: MasonryLoaderRenderer,
  metricCard: MasonryMetricCardRenderer,
  microCard: MasonryMicroCardRenderer,
  notificationBanner: MasonryNotificationBannerRenderer,
  notificationCard: MasonryNotificationCardRenderer,
  progressBar: MasonryProgressBarCardRenderer,
  progressRing: MasonryProgressRingCardRenderer,
  sectionHeader: MasonrySectionHeaderRenderer,
  sidebarLayout: MasonrySidebarLayoutRenderer,
  smallCard: MasonrySmallCardRenderer,
  statusBanner: MasonryStatusBannerRenderer,
  stickyLayout: MasonryStickyLayoutRenderer,
  tabs: MasonryTabsRenderer,
  textAction: MasonryTextActionRenderer,
  verticalLayout: MasonryVerticalLayoutRenderer,
  video: MasonryVideoRenderer,
  accordionItem: MasonryAccordionItemRenderer,
  basicTable: MasonryBasicTableRenderer,
  divider: MasonryDividerRenderer,
  // form renderers
  selectInput: MasonrySelectInputRenderer,
  textInput: MasonryTextInputRenderer,
  button: MasonryButtonRenderer,
  checkboxGroup: MasonryCheckboxRenderer,
  radioGroup: MasonryRadioRenderer,
  segmentedControl: MasonrySegmentControlRenderer
};

// src/masonry-engine/masonry-driver/masonry-driver-node-renderers-registry.ts
var masonryDriverNodeRendererMap = {
  [DEFAULT_NAMESPACE]: MasonryDriverDefaultNodeRendererMap
};
var masonryDriverNodeRendererOverrideMap = {};
var MasonryDriverNodeRenderersRegistry = {
  /**
   *
   * @method registerRenderer use to register renderers per namespace
   * along with the namespace name to be used for {@link getMasonryDriver}.
   * This function expects namespace as first argument and Node type to
   * Renderer map as second argument.
   */
  registerRenderer(namespace, type, renderer) {
    masonryDriverNodeRendererMap[namespace] = masonryDriverNodeRendererMap[namespace] || {};
    if (masonryDriverNodeRendererMap[namespace][type]) {
      throw new Error(
        "Attempting to register a renderer for a type at a namespace where a renderer was already registered for that type!"
      );
    }
    masonryDriverNodeRendererMap[namespace][type] = renderer;
  },
  /**
   * @method overrideRenderer use by app developers to override single renderer for an App
   * for {@link getMasonryDriver}.
   * To override default renderers for a driver, please use namespace "default"
   * Note: All renderers map are driver specific.
   * */
  overrideRenderer(namespace, type, renderer) {
    masonryDriverNodeRendererOverrideMap[namespace] = masonryDriverNodeRendererOverrideMap[namespace] || {};
    masonryDriverNodeRendererOverrideMap[namespace][type] = renderer;
  },
  getNodeRenderersMap() {
    const resolvedRendererMap = merge2(
      {},
      masonryDriverNodeRendererMap,
      masonryDriverNodeRendererOverrideMap
    );
    console.log("[Masonry Driver Renderer Map] : ", resolvedRendererMap);
    return resolvedRendererMap;
  }
};

// src/masonry-engine/masonry-driver/masonry-driver-action-handler-map.tsx
import { trackAnalyticsEvent as trackAnalyticsEvent2 } from "@leagueplatform/analytics";
import {
  postMasonryNodeDismiss,
  deleteMasonryNodeDismiss,
  postMasonryForm
} from "@leagueplatform/masonry-api";

// src/utils/formatSubmitFormResponseBody.ts
var formatSubmitFormResponseBody = (response) => {
  var _a;
  return (_a = response.attributes.formFields) == null ? void 0 : _a.reduce((validateResult, formField) => {
    const newResult = validateResult;
    newResult[formField.nodeId] = {
      statusMessage: formField == null ? void 0 : formField.statusMessage,
      statusType: formField == null ? void 0 : formField.statusType
    };
    return newResult;
  }, {});
};

// src/utils/handle-masonry-link.util.ts
import { getConfig as getConfig2 } from "@leagueplatform/core";
import { isValidUrl } from "@leagueplatform/web-common";
var handleMasonryLink = (navigate, url, event) => {
  var _a, _b;
  const { config } = getConfig2();
  const applicationLinkHandler = (_b = (_a = config.core) == null ? void 0 : _a.customMethods) == null ? void 0 : _b.handleLink;
  const isDeepLink = url == null ? void 0 : url.startsWith("/");
  if (!url)
    return;
  const isExternalLink = isValidUrl(url) && !isValidUrl(url, { hostname: window.location.hostname });
  if (isDeepLink) {
    navigate(url);
  } else if (isExternalLink) {
    event == null ? void 0 : event.preventDefault();
    if (applicationLinkHandler)
      applicationLinkHandler(url);
    else
      window.open(url, "_blank", "noreferrer");
  }
};

// src/masonry-engine/masonry-driver/masonry-driver-action-handler-map.tsx
import { isDev, isNodeTestEnv } from "@leagueplatform/core";
var trackMasonryAnalytics = (event, widgetProperties) => trackAnalyticsEvent2(event, __spreadValues({}, widgetProperties));
var DeeplinkActionHandler = (action, _, __, ___, ____, { navigate }) => {
  const { payload, event } = action;
  handleMasonryLink(navigate, payload.url, event);
};
var DismissActionHandler = (action, emitAction) => {
  const nodeId = action.ancestry[0];
  if (nodeId) {
    return Promise.all([
      // Send a POST request to the API to dismiss the node
      postMasonryNodeDismiss(nodeId),
      // Emit a hide action to hide this node
      emitAction({
        type: "hide",
        namespace: "default",
        ancestry: action.ancestry,
        payload: {
          nodeIds: [nodeId]
        }
      })
    ]);
  }
  return Promise.resolve();
};
var UndismissActionHandler = (action, _, stateController) => __async(void 0, null, function* () {
  var _a;
  deleteMasonryNodeDismiss(action.payload.nodeIds);
  (_a = action.payload.nodeIds) == null ? void 0 : _a.forEach((nodeId) => {
    stateController.setNodeState(nodeId, (state) => __spreadProps(__spreadValues({}, state), {
      isVisible: true
    }));
  });
});
var HideActionHandler = (action, _, stateController) => {
  var _a;
  (_a = action.payload.nodeIds) == null ? void 0 : _a.forEach((nodeId) => {
    stateController.setNodeState(nodeId, (state) => __spreadProps(__spreadValues({}, state), {
      isVisible: false
    }));
  });
};
var ShowActionHandler = (action, _, stateController) => {
  var _a;
  (_a = action.payload.nodeIds) == null ? void 0 : _a.forEach((nodeId) => {
    stateController.setNodeState(nodeId, (state) => __spreadProps(__spreadValues({}, state), {
      isVisible: true
    }));
  });
};
var ToggleVisibilityActionHandler = (action, _, stateController) => {
  var _a;
  (_a = action.payload.nodeIds) == null ? void 0 : _a.forEach((nodeId) => {
    stateController.setNodeState(nodeId, (state) => __spreadProps(__spreadValues({}, state), {
      isVisible: !state.isVisible
    }));
  });
};
var AnalyticsActionHandler = (action) => __async(void 0, null, function* () {
  const { event_name: eventName, payload } = action.payload;
  if (eventName && payload)
    trackMasonryAnalytics(eventName, payload);
});
var OnLoadActionHandler = () => __async(void 0, null, function* () {
});
var ReloadActionHandler = (params, _, __, messagingController) => Promise.all(
  params.payload.nodeIds.map(
    (nodeId) => messagingController.sendMessage(nodeId, {
      type: "reload",
      payload: {
        renderIntermediately: params.payload.renderIntermediately || "loader",
        setQueryParams: (current) => {
          const paramsClone = __spreadValues({}, current);
          const incomingParams = __spreadValues(__spreadValues({}, params.payload.refreshParams || {}), params.payload.queryParams || {});
          Object.entries(incomingParams).forEach(([key, value]) => {
            if (value) {
              paramsClone[key] = value;
            } else {
              delete paramsClone[key];
            }
          });
          return paramsClone;
        }
      }
    })
  )
);
var ReloadOnResizeActionHandler = (params, emitAction) => emitAction({
  type: "reload",
  namespace: params.namespace,
  ancestry: params.ancestry,
  payload: {
    nodeIds: [params.ancestry[0]]
  }
});
var SubmitFormActionHandler = (params, invokeAction, stateController, __, validationController) => __async(void 0, null, function* () {
  const { payload } = params;
  const { formId, formProcessId, onSuccessDeepLink } = payload;
  const fieldNodeIds = stateController.getFormFieldNodesMap(formId);
  if (!fieldNodeIds) {
    return logError(`No form with the form ID ${formId} was found!`);
  }
  const fieldNodes = fieldNodeIds == null ? void 0 : fieldNodeIds.map((id) => __spreadValues({
    nodeId: id
  }, stateController.getNodeState(id)));
  if (!(fieldNodes == null ? void 0 : fieldNodes.length)) {
    return logWarning(
      `No fields associated with form ID ${formId} were found, so not making form submit call.`
    );
  }
  const validationResult = validationController.validateFormFields(fieldNodes);
  validationController.updateFieldNodesWithValidationMessages(
    validationResult,
    fieldNodes,
    stateController
  );
  if (Object.keys(validationResult).length)
    return false;
  try {
    if (!isDev() || isNodeTestEnv()) {
      const response = yield postMasonryForm({
        formId,
        formProcessId,
        fieldNodes
      });
      if (response.status === 400) {
        const formattedResponseBody = formatSubmitFormResponseBody(
          response.data
        );
        if (formattedResponseBody) {
          return validationController.updateFieldNodesWithValidationMessages(
            formattedResponseBody,
            fieldNodes,
            stateController
          );
        }
      } else if (response.status > 399) {
        throw new Error();
      }
    }
    if (onSuccessDeepLink) {
      invokeAction({
        type: "deeplink",
        namespace: params.namespace,
        ancestry: params.ancestry,
        event: params.event,
        payload: { url: onSuccessDeepLink }
      });
    }
  } catch (error) {
    logError(
      `Form submission failed for form ID ${formId} with error: ${error}`
    );
    return invokeAction({
      type: "showModalWithProperties",
      namespace: params.namespace,
      ancestry: params.ancestry,
      event: params.event,
      payload: {
        heading: "Form submission failed",
        body: "Please try again later.",
        ctaLabel: "Dismiss"
      }
    });
  }
  if (isDev()) {
    return invokeAction({
      type: "showModalWithProperties",
      namespace: params.namespace,
      ancestry: params.ancestry,
      event: params.event,
      payload: {
        heading: "\u{1F389}\u{1F389} Success \u{1F389}\u{1F389}",
        body: "Form submitted successfully. HURRAY!!",
        ctaLabel: "Bye"
      }
    });
  }
  return void 0;
});
var MasonrySetNodeStateActionHandler = (params, _, stateController) => {
  const nodeId = params.payload.nodeId || params.ancestry[0];
  stateController.setNodeState(nodeId, (state) => __spreadValues(__spreadValues({}, state), params.payload.state));
};
var MasonryShowModalWithPropertiesActionHandler = (params, _, __, messagingController) => {
  var _a;
  let elementToFocusOnClose = ((_a = params.event) == null ? void 0 : _a.target) || document.activeElement;
  if (!elementToFocusOnClose) {
    console.error(
      "the showModalWithProperties action must include an original DOM event when invoked, so that the opening DOM element can be focused once the modal is dismissed!"
    );
    elementToFocusOnClose = document.body;
  }
  messagingController.sendMessageToInstance({
    type: "showModalWithProperties",
    payload: __spreadProps(__spreadValues({}, params.payload), {
      elementToFocusOnClose
    })
  });
};
var masonryDriverActionHandlerMap = {
  deeplink: DeeplinkActionHandler,
  dismiss: DismissActionHandler,
  undismiss: UndismissActionHandler,
  analytics: AnalyticsActionHandler,
  onLoad: OnLoadActionHandler,
  hide: HideActionHandler,
  show: ShowActionHandler,
  reload: ReloadActionHandler,
  reloadOnResize: ReloadOnResizeActionHandler,
  toggleVisibility: ToggleVisibilityActionHandler,
  submitForm: SubmitFormActionHandler,
  setNodeState: MasonrySetNodeStateActionHandler,
  showModalWithProperties: MasonryShowModalWithPropertiesActionHandler
};

// src/masonry-engine/masonry-driver/get-masonry-driver.ts
var MasonryDriverActionController = createMasonryEngineActionController(masonryDriverActionHandlerMap);
var getMasonryDriver = ({
  rootNodeId,
  queryParams
}) => ({ children }) => children(
  getMasonryRootNode({ rootNodeId }),
  MasonryDriverNodeRenderersRegistry.getNodeRenderersMap(),
  MasonryDriverActionController,
  queryParams
);

// src/masonry-engine/masonry-WS-driver/get-masonry-WS-driver.ts
import { getMasonryWSRootNode } from "@leagueplatform/masonry-api";
import {
  createMasonryEngineActionController as createMasonryEngineActionController2
} from "@leagueplatform/masonry-engine";

// src/masonry-engine/masonry-WS-driver/masonry-WS-driver-node-renderers-registry.ts
import {
  DEFAULT_NAMESPACE as DEFAULT_NAMESPACE2
} from "@leagueplatform/masonry-engine";
import { merge as merge3 } from "lodash";

// src/masonry-engine/masonry-WS-driver/masonry-WS-default-node-renderers-map.tsx
import { WidgetType as WidgetType5, LoaderType } from "@leagueplatform/masonry-api";
import {
  CarouselWSRenderer,
  ExtraSmallSkeletonWSRenderer,
  HeroBannerWSRenderer,
  HeroBannerWSSkeletonRenderer,
  ImageFooterWSRenderer,
  LargeSkeletonWSRenderer,
  LargeVisualCardWSRenderer,
  LayoutWSRenderer,
  MetricCardWSRenderer,
  NotificationBannerWSRenderer,
  NotificationCardWSRenderer,
  ProgressBarCardWSRenderer,
  ProgressRingCardWSRenderer,
  SectionHeaderWSRenderer,
  SmallSkeletonWSRenderer,
  SmallVisualCardWSRenderer,
  TextAndCTACardWSRenderer,
  TwoUpCardWSRenderer,
  WelcomeBanner as WelcomeBanner2,
  XSVisualCardWSRenderer
} from "@leagueplatform/masonry-widgets";
var MasonryWSDriverDefaultNodeRendererMap = {
  [LoaderType.EXTRA_SMALL]: ExtraSmallSkeletonWSRenderer,
  [LoaderType.HERO_BANNER]: HeroBannerWSSkeletonRenderer,
  [LoaderType.LARGE]: LargeSkeletonWSRenderer,
  [LoaderType.SMALL]: SmallSkeletonWSRenderer,
  [WidgetType5.GENERIC_CAROUSEL]: CarouselWSRenderer,
  [WidgetType5.HERO_BANNER]: HeroBannerWSRenderer,
  [WidgetType5.HIDDEN]: () => null,
  [WidgetType5.IMAGE_FOOTER]: ImageFooterWSRenderer,
  [WidgetType5.LARGE_VISUAL_CARD]: LargeVisualCardWSRenderer,
  [WidgetType5.METRIC_CARD]: MetricCardWSRenderer,
  [WidgetType5.NOTIFICATION_BANNER]: NotificationBannerWSRenderer,
  [WidgetType5.NOTIFICATION_CARD]: NotificationCardWSRenderer,
  [WidgetType5.PROGRESS_BAR]: ProgressBarCardWSRenderer,
  [WidgetType5.PROGRESS_RING]: ProgressRingCardWSRenderer,
  [WidgetType5.SECTION_HEADER]: SectionHeaderWSRenderer,
  [WidgetType5.SMALL_VISUAL_CARD]: SmallVisualCardWSRenderer,
  [WidgetType5.STACK]: LayoutWSRenderer,
  [WidgetType5.TEXT_WITH_CTA_CARD]: TextAndCTACardWSRenderer,
  [WidgetType5.TWO_UP_CARD]: TwoUpCardWSRenderer,
  [WidgetType5.WELCOME_BANNER]: WelcomeBanner2,
  [WidgetType5.XS_VISUAL_CARD]: XSVisualCardWSRenderer,
  containerSpinner: MasonrySpinner
};

// src/masonry-engine/masonry-WS-driver/masonry-WS-driver-node-renderers-registry.ts
var masonryWSDriverNodeRendererMap = {
  [DEFAULT_NAMESPACE2]: MasonryWSDriverDefaultNodeRendererMap
};
var masonryWSDriverNodeRendererOverrideMap = {};
var MasonryWSDriverNodeRenderersRegistry = {
  /**
   *
   * @method registerRenderer use to register renderers per namespace
   * along with the namespace name to be used for {@link getMasonryWSDriver}.
   * This function expects namespace as first argument and Node type to
   * Renderer map as second argument.
   */
  registerRenderer(namespace, type, renderer) {
    masonryWSDriverNodeRendererMap[namespace] = masonryWSDriverNodeRendererMap[namespace] || {};
    if (masonryWSDriverNodeRendererMap[namespace][type]) {
      throw new Error(
        "Attempting to register a renderer for a type at a namespace where a renderer was already registered for that type!"
      );
    }
    masonryWSDriverNodeRendererMap[namespace][type] = renderer;
  },
  /**
   * @method overrideRenderer use by app developers to override single renderer for an App
   * for {@link getMasonryWSDriver}.
   * To override default renderers for a driver, please use namespace "default"
   * Note: All renderers map are driver specific.
   * */
  overrideRenderer(namespace, type, renderer) {
    masonryWSDriverNodeRendererOverrideMap[namespace] = masonryWSDriverNodeRendererOverrideMap[namespace] || {};
    masonryWSDriverNodeRendererOverrideMap[namespace][type] = renderer;
  },
  getNodeRenderersMap() {
    const resolvedRendererMap = merge3(
      {},
      masonryWSDriverNodeRendererMap,
      masonryWSDriverNodeRendererOverrideMap
    );
    console.log("[Masonry WS Driver Renderer Map] : ", resolvedRendererMap);
    return resolvedRendererMap;
  }
};

// src/masonry-engine/masonry-WS-driver/get-masonry-WS-driver.ts
var MasonryWSDriverActionController = createMasonryEngineActionController2({});
var getMasonryWSDriver = (config) => ({ children }) => children(
  getMasonryWSRootNode(config),
  MasonryWSDriverNodeRenderersRegistry.getNodeRenderersMap(),
  MasonryWSDriverActionController
);

// src/components/generic-masonry-page/generic-masonry-page.component.tsx
var DefaultPageWrapperComponent = ({ children }) => /* @__PURE__ */ React19.createElement(StackLayout3, { css: { padding: "$two" } }, children);
var GenericMasonryPage = ({
  pageWrapperComponent = DefaultPageWrapperComponent
}) => {
  var _a, _b, _c;
  const { version: versionParam, id: idParam } = useParams2();
  const searchParam = useSearchParams();
  const versionSearchParam = searchParam.get("version");
  const idSearchParam = searchParam.get("nodeId");
  const id = idParam || idSearchParam;
  const version = versionParam || versionSearchParam;
  if (!id) {
    logError(`'id' URL param not found.`);
    return null;
  }
  const searchParams = new URLSearchParams(
    new URL((_a = window.location) == null ? void 0 : _a.href).search
  );
  const screenName = (_b = searchParams.get("screenName")) != null ? _b : "";
  const productArea = (_c = searchParams.get("productArea")) != null ? _c : "";
  const driver = (() => {
    switch (version) {
      case "1.5":
        return getMasonryWSDriver({
          appId: id,
          screenName,
          productArea
        });
      case "2.0":
        return getMasonryDriver({ rootNodeId: id });
      case "2":
        return getMasonryDriver({ rootNodeId: id });
      default:
        logError(`version ${version} not supported for generic Masonry page.`);
        return null;
    }
  })();
  return driver ? React19.createElement(
    pageWrapperComponent,
    null,
    /* @__PURE__ */ React19.createElement(MasonryEngine, { driver })
  ) : null;
};
var GenericMasonryPageRoute = ({
  baseName,
  pageWrapperComponent
}) => /* @__PURE__ */ React19.createElement(
  Route,
  {
    path: `${baseName}/:version/:id`,
    element: /* @__PURE__ */ React19.createElement(React19.Fragment, null, "(", /* @__PURE__ */ React19.createElement(GenericMasonryPage, { pageWrapperComponent }), ")")
  }
);

// src/index.ts
var src_default = { init: initMasonry };
export {
  GenericMasonryPage,
  GenericMasonryPageRoute,
  MASONRY_ROUTES,
  MasonryDriverActionController,
  MasonryDriverDefaultNodeRendererMap,
  MasonryDriverNodeRenderersRegistry,
  MasonryPDF,
  MasonryWSDriverDefaultNodeRendererMap,
  MasonryWSDriverNodeRenderersRegistry,
  WidgetTypeToSimpleComponentMap,
  src_default as default,
  getMasonryDriver,
  getMasonryWSDriver
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/masonry'] = window.leagueSDKsPresent['@leagueplatform/masonry'] || [];
    window.leagueSDKsPresent['@leagueplatform/masonry'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/masonry'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/masonry module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map